import { render, staticRenderFns } from "./ApplyFee.vue?vue&type=template&id=473cbe2d&scoped=true"
import script from "./ApplyFee.vue?vue&type=script&lang=js"
export * from "./ApplyFee.vue?vue&type=script&lang=js"
import style0 from "./ApplyFee.vue?vue&type=style&index=0&id=473cbe2d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473cbe2d",
  null
  
)

export default component.exports